/**
 * @generated SignedSource<<537ae5c04d1f41cab7d7ddd2a92b022b>>
 * @relayHash 7d6f6442604633db9cad5b7f7d7a2f67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 84469a0d76dc498b9bea3fa90afbc26c6dfbb81e4cbaab08d9021441f3f09ade

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceLength = "LONG" | "MEDIUM" | "SHORT" | "%future added value";
export type ConfluenceTone = "CONVERSATIONAL" | "PLAYFUL" | "PROFESSIONAL" | "SURPRISE" | "%future added value";
export type ConfluenceUpdateAudioPreferenceInput = {
  length?: ConfluenceLength | null | undefined;
  playbackSpeed?: number | null | undefined;
  tone?: ConfluenceTone | null | undefined;
};
export type CustomizePanelUpdateAudioPreferenceMutation$variables = {
  cloudId: string;
  input: ConfluenceUpdateAudioPreferenceInput;
};
export type CustomizePanelUpdateAudioPreferenceMutation$data = {
  readonly confluence_updateAudioPreference: {
    readonly preference: {
      readonly length: ConfluenceLength;
      readonly playbackSpeed: number;
      readonly tone: ConfluenceTone;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type CustomizePanelUpdateAudioPreferenceMutation = {
  response: CustomizePanelUpdateAudioPreferenceMutation$data;
  variables: CustomizePanelUpdateAudioPreferenceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceUpdateAudioPreferencePayload",
    "kind": "LinkedField",
    "name": "confluence_updateAudioPreference",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "ConfluenceAudioPreference",
        "kind": "LinkedField",
        "name": "preference",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "playbackSpeed"
          },
          {
            "kind": "ScalarField",
            "name": "length"
          },
          {
            "kind": "ScalarField",
            "name": "tone"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CustomizePanelUpdateAudioPreferenceMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CustomizePanelUpdateAudioPreferenceMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7d6f6442604633db9cad5b7f7d7a2f67",
    "id": "84469a0d76dc498b9bea3fa90afbc26c6dfbb81e4cbaab08d9021441f3f09ade",
    "metadata": {},
    "name": "CustomizePanelUpdateAudioPreferenceMutation",
    "operationKind": "mutation",
    "text": "mutation CustomizePanelUpdateAudioPreferenceMutation($input:ConfluenceUpdateAudioPreferenceInput!,$cloudId:ID!){confluence_updateAudioPreference(cloudId:$cloudId,input:$input){success,preference{playbackSpeed,length,tone}}}"
  }
};
})();

(node as any).hash = "655ac66119013917736398a22f4af9cd";

export default node;
